"use strict"

if(window.Laravel && window.Laravel.apiToken !== undefined) {
    //window.axios.defaults.baseURL = `${process.env.MIX_APP_URL}`
    window.axios.defaults.headers.common['Accept'] = 'application/json'
    window.axios.defaults.headers.common['Authorization'] = `Bearer ${window.Laravel.apiToken}`
}
